import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeProfile } from "../../../Redux/reducer/RequestReducer";
import { TbPencilMinus } from "react-icons/tb";
import {
	useAddCoinsMutation,
	useChangeCategoriesMutation,
	useChangeGradeMutation,
	useGetContractorQuery,
	useRemoveCoinsMutation,
} from "../../../Redux/Api/Contractor";
import { useParams } from "react-router-dom";
import {
	MdOutlineCancel,
} from "react-icons/md";
import { useCategoriesNameQuery } from "../../../Redux/Api/NamesAPI";
import { CategoryFilter } from "./components/CategoryFilter";
import { RootState } from "../../../Redux/store";
import { Categories } from "../types";
import { setSelectedCategories, setSelectedCategoriesPrice } from "../../../Redux/reducer/Filter";
import { useChangePasswordMutation } from "../../../Redux/Api/Contractor";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContractorOrderHistory from "./ContractorOrderHistory";
import ContractorMessage from "./contractorMessage";
import "./components/Customer.css";
import { BiCoinStack, BiEdit } from "react-icons/bi";
import AdminContractorReward from "./adminContractorReward";
import { ContractorCategoryPriceFilter } from "./components/ContractorCategoryPriceFilter";

export const Customer = () => {
	const dispatch = useDispatch();
	const { id } = useParams<{ id: string }>();

	const [selectedOption, setSelectedOption] = useState<string | null>(null);
	const [comp, setComp] = useState<string | null>(null);
	const [activeComponent, setActiveComponent] = useState("history");
	const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
	const [isCatgeoryOpen, setIsCategoryOpen] = useState<boolean>(false);
	const [isCatgeoryPriceOpen, setIsCategoryPriceOpen] = useState<boolean>(false);
	const [rewardValue, setRewardValue] = useState<number | null>(null);
	const [operation, setOperation] = useState("");
	const [grade, setGrade] = useState<{ grade: string }>({ grade: "" });
	const [categories, setCategories] = useState<{ category: string[] }>({
		category: [],
	});
	const [categoriesPrice, setCategoriesPrice] = useState<{ priceCategory: string[] }>({
		priceCategory: [],
	});
	const [showModal, setShowModal] = useState(false);
	const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

	const { refetch, data } = useGetContractorQuery(id);
	const [addCoins] = useAddCoinsMutation();
	const [removeCoins] = useRemoveCoinsMutation();
	const [changeCategory] = useChangeCategoriesMutation();
	const [changePassword, { data: changedPassword }] =
		useChangePasswordMutation();
	const [password, setPassword] = useState("");

	const handleOpenModal = () => {
		if (rewardValue) {
			setShowModal(true);
		}
	};

	const handleCloseModal = () => {
		setShowModal(false);
	};

	const handleConfirm = (id: string) => {
		if (operation === "add") {
			addCoins({ id, body: { coins: rewardValue } });
			setOperation("");
			forceRenderHistory();
		} else if (operation === "subtract") {
			removeCoins({ id, body: { coins: rewardValue } });
			setOperation("");
			forceRenderHistory();
		}
		setShowModal(false);
	};
	const [changeGrade] = useChangeGradeMutation();

	const { data: categoriesResponse } = useCategoriesNameQuery(
		{},
		{ refetchOnMountOrArgChange: true, keepPreviousData: true }
	);
	const options = ["a", "b", "c"];
	const [categoryMap, setCategoryMap] = useState<{ id: string; name: string }[]>([]);
	const [categoryMapPrice, setCategoryMapPrice] = useState<{ id: string; name: string }[]>([]);

	const allCategories = data?.message?.categoryProduct;
	const allCategoriesPrice = data?.message?.category_price;

	useEffect(() => {
		if (allCategories) {
			dispatch(setSelectedCategories(allCategories));
		}
		if (allCategoriesPrice) {
			dispatch(setSelectedCategoriesPrice(allCategoriesPrice));
		}
	}, [allCategories, allCategoriesPrice]);

	const handleReward = (e: any) => {
		setRewardValue(e.target.value);
	};



	const handleSelect = (option: string) => {
		setSelectedOption(option);
		setGrade({ grade: option });
		setIsDropdownOpen(false);
	};

	useEffect(() => {
		if (selectedOption && grade) {
			changeGrade({ id, body: grade });
		}
	}, [selectedOption, grade]);

	const selectedCategories = useSelector((state: RootState) => state.selection.selectedCategories);
	const selectedCategoriesPrice = useSelector((state: RootState) => state.selection.selectedCategoriesPrice);
	console.log("Redux Selected Categories Price:", selectedCategoriesPrice);
	useEffect(() => {
		if (categoriesResponse && selectedCategories.length > 0) {
			const selectedCategoryDetails = categoriesResponse?.data
				?.filter((category: Categories) =>
					selectedCategories.includes(category.id)
				)
				.map((category: Categories) => category.name);
			setCategoryMap(selectedCategoryDetails);
		}

		if (selectedCategories.length === 0) {
			setCategoryMap(selectedCategories);
		}
	}, [categoriesResponse, selectedCategories]);
	useEffect(() => {
		if (categoriesResponse && selectedCategoriesPrice.length > 0) {
			const selectedCategoryDetails = categoriesResponse?.data
				?.filter((category: Categories) =>
					selectedCategoriesPrice.includes(category.id)
				)
				.map((category: Categories) => category.name);
			setCategoryMapPrice(selectedCategoryDetails);
		}

		if (selectedCategoriesPrice.length === 0) {
			setCategoryMapPrice(selectedCategoriesPrice);
		}
	}, [categoriesResponse, selectedCategoriesPrice]);




	const toggleDropdown = () => {
		setIsDropdownOpen(!isDropdownOpen);
	};

	const CategoryToChange = () => {
		setCategories({ category: selectedCategories });
		setIsCategoryOpen(false);
	};
	const CategoryPriceToChange = () => {
		setCategoriesPrice({ priceCategory: selectedCategoriesPrice });
		setIsCategoryPriceOpen(false);
	};

	useEffect(() => {
		if (categories.category.length > 0) {
			const body = {
				category: categories.category,
			};
			let catType = "categoryProduct"

			changeCategory({ id, catType, body });
			toast.success('Category updated successfully!');
			setCategories({ category: [] });
		}

		if (categoriesPrice.priceCategory.length > 0) {
			const body = {
				category: categoriesPrice.priceCategory,
			};
			let catType = "category_price"

			changeCategory({ id, catType, body });
			toast.success('Category Price Wise updated successfully!');
			setCategoriesPrice({ priceCategory: [] });
		}
	}, [categories, categoriesPrice]);



	const togglePasswordModal = () => {
		setIsPasswordModalOpen(!isPasswordModalOpen);
	};

	const toggleChangePassword = (id: string) => {
		setIsPasswordModalOpen(!isPasswordModalOpen);
		changePassword({
			body: {
				newPassword: password,
			},
			id,
		});
	};

	useEffect(() => {
		if (changedPassword?.message) {
			toast.success("Password changed successfully!");
		}
	}, [changedPassword]);

	const [historyKey, setHistoryKey] = useState(0);

	const forceRenderHistory = () => {
		setHistoryKey((prevKey) => prevKey + 1);
	};


	const renderComponent = () => {
		switch (activeComponent) {
			case "history":
				return <ContractorOrderHistory />;
			case "message":
				return <ContractorMessage />;
			case "reward":
				return <AdminContractorReward />;
			default:
				return <ContractorOrderHistory />;
		}
	};

	return (

		<div className="mx-3 pb-3 ">
			{/* tabs start */}
			<div
				className="flex items-center gap-2 h-[45px] bg-white text-black text-[14px] rounded-xl mb-3 w-fit p-[4px] font-medium"
				style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
			>
				<div
					onClick={() => setActiveComponent("history")}
					className={`rounded-xl cursor-pointer h-full flex items-center justify-center px-3 py-1 ${activeComponent === "history"
						? "border-[#334155] bg-[#334155] text-white"
						: ""
						}`}
				>
					History
				</div>
				<div onClick={() => setActiveComponent("message")}
					className={`rounded-xl cursor-pointer h-full flex items-center justify-center px-3 py-1 ${activeComponent === "message"
						? "border-[#334155] bg-[#334155] text-white"
						: ""
						}`}
				>
					Message
				</div>
				<div
					onClick={() => setActiveComponent("reward")}
					className={`rounded-xl cursor-pointer h-full flex items-center justify-center px-3 py-1 ${activeComponent === "reward"
						? "border-[#334155] bg-[#334155] text-white"
						: ""
						}`}
				>
					Reward
				</div>
			</div>

			{/* tabs end */}

			{/* contractor Type start */}
			<div
				className="w-full flex flex-col text-[#7D7D7D] h-auto rounded-xl bg-white p-4 font-medium space-y-1 mb-3 box-border"
				style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>
				<div className="flex justify-between items-center ">
					<div>
						Contractor Name :{" "}
						<span className="text-black ">
							{data?.message?.name}
						</span>
					</div>
					<div className="bg-[#FFF7ED] text-[#F97316] py-1 px-2 rounded-lg  shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)]">
						Total Pending Reward : 00
					</div>
				</div>
				<div className="flex items-center gap-2 ">
					Grade :{" "}
					<span className="text-black ">
						{data?.message?.contractorGrade.toUpperCase()}
					</span>{" "}
					<div
						className="text-black border rounded-md p-[1px] cursor-pointer relative "
						onClick={toggleDropdown}>
						<BiEdit />
						{isDropdownOpen && (
							<div className="absolute top-2 right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 border-[6px] border-[#334155]">
								{options.map((option) => (
									<div
										key={option}
										onClick={() => handleSelect(option)}
										className="cursor-pointer px-6 py-1 text-sm text-gray-700 hover:bg-gray-100">
										{option.toUpperCase()}
									</div>
								))}
							</div>
						)}
					</div>
				</div>

				<div className="flex items-center gap-2 ">
					Total Balance Reward: :{" "}
					<span className="text-black flex items-center gap-[1px]  ">
						{data?.message?.totalReward}{" "}
						<span className="text-[#FF9900]">
							<BiCoinStack />
						</span>
					</span>
					<select
						id="operation"
						value={operation}
						onChange={(e) => setOperation(e.target.value)}
						className="bg-gray-50 border cursor-pointer border-gray-300 text-gray-900 text-sm rounded-xl focus:ring-blue-500 focus:border-[0.5px] focus:border-blue-500 block w-[110px] py-[10px] px-3 "
						style={{
							boxShadow: "0px 0px 7.6px 0px #00000040 inset",
						}}>
						<option>Select</option>
						<option value="add">Add</option>
						<option value="subtract">Subtract</option>
					</select>
					{operation === "add" ? (
						<div className="flex gap-4 mr-auto ml-2">
							<input
								className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-xl focus:ring-blue-500 focus:border-[0.5px] focus:border-blue-500 block w-full py-2 px-3"
								placeholder="Enter the Rewards"
								onChange={handleReward}
								style={{
									boxShadow:
										"0px 0px 7.6px 0px #00000040 inset",
								}}
							/>
							<button
								className="py-2 px-5 text-white bg-[#334155] rounded-xl"
								onClick={handleOpenModal}>
								Add
							</button>
						</div>
					) : operation === "subtract" ? (
						<div className="flex gap-4 mr-auto  ml-2">
							<input
								className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-xl focus:ring-blue-500 focus:border-[0.5px] focus:border-blue-500 block w-full py-2 px-3"
								placeholder="Enter the Rewards"
								onChange={handleReward}
								style={{
									boxShadow:
										"0px 0px 7.6px 0px #00000040 inset",
								}}
							/>
							<button
								className="py-2 px-5 text-white bg-[#334155] rounded-xl"
								onClick={handleOpenModal}>
								Subtract
							</button>
						</div>
					) : (
						""
					)}
					{showModal && (
						<div className="fixed inset-0 z-50 flex items-center justify-center">
							<div className="absolute inset-0 bg-black opacity-50"></div>
							<div className="relative  mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
								<div className="mt-3 text-center">
									<h3 className="text-lg leading-6 font-medium text-gray-900">
										Are you sure?
									</h3>
									<div className="mt-2 px-7 py-3">
										<p className="text-sm text-gray-500">
											Do you really want to proceed
											with this action?
										</p>
									</div>
									<div className="items-center px-4 py-3">
										<button
											className="px-4 py-2 bg-green-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-green-600"
											onClick={() =>
												handleConfirm(
													data?.message?._id
												)
											}>
											Yes
										</button>
										<button
											className="px-4 py-2 bg-red-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-red-600 mt-2"
											onClick={handleCloseModal}>
											No
										</button>
									</div>
								</div>
							</div>
						</div>
					)}
					{isPasswordModalOpen && (
						<div className="fixed inset-0 z-50 flex items-center justify-center">
							<div className="absolute inset-0 bg-black opacity-50"></div>

							<div
								className="relative bg-white p-8 rounded-xl shadow-lg w-[350px] z-10 flex-col"
								style={{
									boxShadow:
										"4px 4px 38.5px 0px #0000004D, -4px -4px 38.5px 0px #0000004D",
								}}>
								<div
									className="absolute right-2 top-2 text-2xl cursor-pointer text-[#000000]"
									onClick={togglePasswordModal}>
									<MdOutlineCancel />
								</div>

								<div className="w-16 h-16 font-semibold text-2xl mx-auto flex justify-center items-center rounded-full  ring-2  p-1  ring-blue-500">
									{
										data?.message?.avatar ? <img src={data?.message?.avatar} alt="" className="w-full h-full object-cover rounded-full " /> : <span className="text-blue-500 text-3xl font-bold">
											{data?.message?.name
												?.charAt(0)
												.toUpperCase()}
										</span>
									}


								</div>

								<div className="text-[#838383] mx-auto my-1 font-bold text-center">
									{data?.message?.name || "-"}
								</div>

								<div className="flex justify-center items-center gap-2">
									<svg
										width={27}
										height={27}
										viewBox="0 0 39 39"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										xmlnsXlink="http://www.w3.org/1999/xlink">
										<rect
											width={39}
											height={39}
											fill="url(#pattern0_930_864)"
										/>
										<defs>
											<pattern
												id="pattern0_930_864"
												patternContentUnits="objectBoundingBox"
												width={1}
												height={1}>
												<use
													xlinkHref="#image0_930_864"
													transform="scale(0.00195312)"
												/>
											</pattern>
											{/* <image
												id="image0_930_864"
												width={512}
												height={512}
												xlinkHref="data:image/png;base64,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"
											/> */}
										</defs>
									</svg>

									<h2 className="text-2xl font-semibold text-black">
										Reset Password
									</h2>
								</div>

								<div className="w-full mx-auto mt-4 shadow-md border rounded-xl p-3 flex flex-col items-center">
									<div className="pb-2">
										<label
											htmlFor=""
											className="text-[#000000]">
											Enter the new password
										</label>
										<input
											type="password"
											className="w-full border-[3px] border-[#1E436E] rounded-md py-1 px-2 mt-1 text-[#000000]"
											value={password}
											onChange={(e) =>
												setPassword(e.target.value)
											}
											required
										/>
									</div>

									<button
										onClick={() =>
											toggleChangePassword(
												data?.message?._id
											)
										}
										className="py-1 px-4 bg-[#1E436E] text-white font-bold rounded-md mt-2 text-center">
										Reset Now
									</button>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
			{/* contractor Type end */}
			{/* Category Assign start */}
			<div className="w-full flex flex-col bg-white p-4 mb-3 box-borde h-auto rounded-xl " style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>
				<div className="w-full flex flex-col  md:flex-row justify-between text-[#7D7D7D] border-b py-3  font-medium space-y-1 r"
				>
					<div className="flex items-center gap-[6px] ">
						<div className="text-[#8B8D97] font-[700] ">
							Category Assign :
						</div>

						<div className="w-[600px] overflow-hidden">
							<div className="flex overflow-x-auto scrollbar-custom text-black">
								{categoryMap &&
									categoryMap.map((i: any, index: number) => (
										<div
											key={index}
											className="font-[700] w-full  text-center leading-[28px] tracking-[1px] px-2 flex nowrap whitespace-nowrap border-r-2">
											{i}
										</div>
									))}
							</div>
						</div>
					</div>
					<div className="relative">
						<button
							onClick={() => {
								setIsCategoryOpen(true)
								setIsCategoryPriceOpen(false)
							}}
							className="flex items-center gap-1 py-1 rounded-xl px-2 border-2 text-sm border-[#334155] bg-[#334155] text-white  ">
							Select <TbPencilMinus />
						</button>
						{isCatgeoryOpen && (
							<div className="absolute right-2 top-9 border rounded-[4px] bg-white w-[360px] h-[300px] z-30">
								{/* Wrap CategoryFilter with a relative container */}
								<div className="relative w-full h-full ">
									{/* Custom buttons positioned absolutely */}
									<div className="absolute bottom-0 left-0 right-0 flex  items-center justify-center gap-2 p-2  bg-white z-10">
										<button
											className="px-[12px] py-[8px] border-[#334155] text-[#334155] border rounded-[4px] w-full justify-center items-center flex cursor-pointer"
											onClick={() =>
												setIsCategoryOpen(false)
											}>
											Cancel
										</button>
										<button
											className="px-[12px] py-[8px] bg-[#334155] text-[#FFF] border rounded-[4px] w-full justify-center items-center flex cursor-pointer"
											onClick={() => CategoryToChange()}>
											Add
										</button>
									</div>
									<CategoryFilter />
								</div>
							</div>
						)}
					</div>
				</div>
				<div className="w-full flex flex-col  md:flex-row justify-between text-[#7D7D7D] py-3  font-medium space-y-1 r"
				>
					<div className="flex items-center gap-[6px] ">
						<div className="text-[#8B8D97] font-[700] ">
							Price Category Assign :
						</div>

						<div className="w-[600px] overflow-hidden">
							<div className="flex overflow-x-auto scrollbar-custom text-black">
								{categoryMapPrice &&
									categoryMapPrice?.map((i: any, index: number) => (
										<div
											key={`${index}I`}
											className="font-[700] w-full  text-center leading-[28px] tracking-[1px] px-2 flex nowrap whitespace-nowrap border-r-2">
											{i}
										</div>
									))}
							</div>
						</div>
					</div>
					<div className="relative">
						<button
							onClick={() => {
								setIsCategoryPriceOpen(true)
								setIsCategoryOpen(false)
							}}
							className="flex items-center gap-1 py-1 rounded-xl px-2 border-2 text-sm border-[#334155] bg-[#334155] text-white  ">
							Select Price  <TbPencilMinus />
						</button>
						{isCatgeoryPriceOpen && (
							<div className="absolute right-2 top-9 border rounded-[4px] bg-white w-[360px] h-[300px] z-30">
								{/* Wrap CategoryFilter with a relative container */}
								<div className="relative w-full h-full ">
									{/* Custom buttons positioned absolutely */}
									<div className="absolute bottom-0 left-0 right-0 flex  items-center justify-center gap-2 p-2  bg-white z-10">
										<button
											className="px-[12px] py-[8px] border-[#334155] text-[#334155] border rounded-[4px] w-full justify-center items-center flex cursor-pointer"
											onClick={() =>
												setIsCategoryPriceOpen(false)
											}>
											Cancel
										</button>
										<button
											className="px-[12px] py-[8px] bg-[#334155] text-[#FFF] border rounded-[4px] w-full justify-center items-center flex cursor-pointer"
											onClick={() => CategoryPriceToChange()}>
											Add
										</button>
									</div>
									<ContractorCategoryPriceFilter />
								</div>
							</div>
						)}
					</div>
				</div>

			</div>

			{/* Category Assign end */}
			<div className="w-full   flex flex-col justify-between text-[#7D7D7D] h-auto rounded-xl bg-white p-4 font-medium space-y  mb-3 box-border  shadow-md">
				<div className="flex overflow-auto w-full ">
					<table className="table-auto w-full min-w-full divide-y divide-gray-200 relative">
						<thead className="bg-white">
							<tr className="border-t">
								<th className="px-6 py-3 text-left text-sm font-inter text-[#1E293B]"></th>
								<th className="px-6 py-3 text-left text-sm font-inter text-[#1E293B]">
									Name
								</th>
								<th className="px-6 py-3 text-left text-sm font-inter text-[#1E293B]">
									Contact
								</th>
								<th className="px-6 py-3 text-left text-sm font-inter text-[#1E293B]">
									Contractor Type
								</th>
								<th className="px-6 py-3 text-left text-sm font-inter text-[#1E293B]">
									City
								</th>
								<th className="px-6 py-3 text-left text-sm font-inter text-[#1E293B]">
									Gst
								</th>
								<th className="px-6 py-3 text-left text-sm font-inter text-[#1E293B]">
									Grade
								</th>
								<th className="px-6 py-3 text-left text-sm font-inter text-[#1E293B]">
									Password
								</th>
							</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200">
							<tr>
								<td className="px-6 py-4 whitespace-nowrap font-inter text-sm text-[#6E7079] cursor-pointer">
									{/* {data?.message?.name}  */}
								</td>
								<td className="px-6 py-4 whitespace-nowrap font-inter text-sm text-[#6E7079]">
									{data?.message?.name || "-"}
								</td>
								<td className="px-6 py-4 whitespace-nowrap font-inter text-sm text-[#6E7079]">
									{data?.message?.phoneNumber || "-"}
								</td>
								<td className="px-6 py-4 whitespace-nowrap font-inter text-sm text-[#6E7079]">
									{/* {data?.message?.phoneNumber}  */}
								</td>
								<td className="px-6 py-4 whitespace-nowrap font-inter text-sm text-[#6E7079]">
									{data?.message?.city || "-"}
								</td>
								<td className="px-6 py-4 whitespace-nowrap font-inter text-sm text-[#6E7079]">
									{data?.message?.gst || "-"}
								</td>
								<td className="px-6 py-4 whitespace-nowrap font-inter text-sm text-[#6E7079]">
									{data?.message?.contractorGrade || "-"}
								</td>
								<td className="px-6 py-4 whitespace-nowrap font-inter text-sm text-[#6E7079]">
									<span
										className="bg-blue-500  py-1 px-2 cursor-pointer text-white font-medium rounded-xl shadow-lg"
										onClick={togglePasswordModal}>
										Change Password
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			{renderComponent()}
		</div>


	);
};
